import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the very top on every route (pathname) change.
 * Uses useLayoutEffect so the reset happens before the browser paints the
 * new page, avoiding any residual scroll offset.
 * Anchor navigation (links with a #hash) is preserved.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return; // let in-page anchor scrolling handle #sections
    const reset = () => {
      // Override global CSS `scroll-behavior: smooth` so the jump is instant.
      const html = document.documentElement;
      const prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, 0);
      html.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      html.style.scrollBehavior = prev;
    };
    reset();
    // Run again after the mobile menu's body-scroll-lock cleanup effect fires.
    const t = setTimeout(reset, 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
